import { FormlyExtension, FormlyFieldConfig } from '@ngx-formly/core';

const DELIMITER_PATTERN = /[,;/\s]+/;
const NORMALIZED_DELIMITER = ', ';

export function normalizeDelimiters(value: string): string {
  return value
    .split(DELIMITER_PATTERN)
    .map((item) => item.trim())
    .filter((item) => item.length > 0)
    .join(NORMALIZED_DELIMITER);
}

export class NormalizeDelimitersOnBlurExtension implements FormlyExtension {
  onPopulate(field: FormlyFieldConfig): void {
    if (
      !field.props?.['normalizeDelimitersOnBlur'] ||
      field.props['_normalizeDelimitersOnBlurAttached']
    ) {
      return;
    }
    field.props['_normalizeDelimitersOnBlurAttached'] = true;

    const existingBlur = field.props.blur;
    field.props.blur = (f, event) => {
      existingBlur?.(f, event);
      const control = f.formControl;
      if (typeof control?.value === 'string') {
        control.setValue(normalizeDelimiters(control.value));
      }
    };
  }
}
